import { CircularProgress, Stack } from '@mui/material'

/** Fallback de Suspense para chunks de página cargados de forma diferida. */
export function PageLoader() {
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ minHeight: '50vh' }}>
      <CircularProgress size={32} thickness={4} />
    </Stack>
  )
}
